var _ellipse, _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavebg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 438,
    viewBox: "0 0 346 438",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 188.236,
    cy: 97.5,
    rx: 97,
    ry: 97.5,
    fill: "url(#paint0_radial)",
    fillOpacity: 0.39
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 199.246,
    y: 324.797,
    width: 24.0869,
    height: 81.9101,
    transform: "rotate(-20.0567 199.246 324.797)",
    fill: "#FCCC63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.227 422.887C241.227 422.887 194.328 369.869 229.606 364.337C264.883 358.805 263.392 414.028 263.392 414.028L241.227 422.887Z",
    fill: "#A0616A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 157.863,
    y: 314.842,
    width: 24.0869,
    height: 74.4859,
    transform: "rotate(22.2946 157.863 314.842)",
    fill: "#FCCC63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.852 392.742C110.852 392.742 146.379 346.017 159.084 362.998C171.789 379.979 136.898 417.177 136.898 417.177L110.852 392.742Z",
    fill: "#FFB8B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.921 222.501L164.974 202.777L175.82 189.016L182.99 179.996L194.453 167.449L193.098 178.443L192.811 186.993L193.132 194.624L194.066 200.117L195.452 204.245L197.457 209.885L200.682 215.986L204.979 222.698L209.435 229.4L214.195 234.737L219.732 242.514L225.101 249.521L230.943 260.193L237.357 251.026L237.217 258.806L237.539 266.594L239.246 277.126L238.506 288.277L236.997 296.829L233.04 309.964L228.16 318.83L220.515 327.09L214.101 332.144L203.236 337.207L195.122 339.202L186.09 339.379L180.112 338.778L172.145 336.047L164.94 332.396L158.652 326.607L152.51 319.445L147.44 312.586L141.903 300.687L138.817 290.009L136.81 278.873L136.938 268.95L137.529 257.8L138.421 248.329L138.392 234.135L136.998 227.111L134.535 220.098L130.536 213.229L136.051 214.897L144.95 218.545L152.921 222.501Z",
    fill: "#EE1E14",
    stroke: "#EE1E14",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.955 226.602L156.168 232.489L161.772 238.669L166.288 244.259L170.895 251.245L172.802 255.136L174.29 253.03L175.182 248.436L175.887 239.284L175.337 225.648L176.431 212.3L181.572 200.162L186.95 191.557L190.735 185.552L188.752 191.35L189.588 206.84L191.219 213.867L193.81 219.417L211.362 250.153L214.265 256.948L215.489 263.64L215.902 270.732L216.407 275.624L217.115 280.418L218.12 283.711L221.223 285.409L225.127 285.4L228.216 284.193L229.933 281.928L231.523 277.729L232.508 271.536L233.518 277.125L234.735 284.921L233.959 297.712L231.59 309.702L226.817 320.506L221.23 326.514L213.055 332.122L205.274 336.343L198.477 338.548L192.49 339.161L187.491 339.375L181.899 338.786L176.295 336.801L170.892 333.412L165.691 329.828L160.953 324.106L154.837 313.52L151.648 304.88L150.308 297.843L149.418 290.294L148.774 282.363L148.962 275.271L149.85 269.174L151.134 262.273L152.818 256.37L154.905 249.573L155.697 244.078L155.379 238.982L153.166 232.389L149.955 226.602Z",
    fill: "#F38F19",
    stroke: "#F38F19",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.928 217.244L188.645 231.943L195.601 246.941L200.316 257.887L204.67 269.359L208.894 282.53L211.394 294.006L212.154 302.746L211.798 309.532L210.701 316.969L208.606 322.061L206.033 328.46L202.698 332.638L198.879 335.519L193.813 338.011L188.407 339.374L183.925 338.947L178.857 336.735L173.661 333.357L169.941 327.229L168.193 321.105L167.199 316.928L166.93 310.276L167.039 302.45L168.386 294.22L171.947 284.822L176.26 276.853L181.426 265.886L184.247 257.396L185.219 251L184.714 242.917L183.451 231.305L179.928 217.244Z",
    fill: "#F3B326",
    stroke: "#F3B326",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.263 306.31L174.593 297.249L177.892 289.328L180.641 282.56L183.942 275.358L187.658 268.876L192.247 262.454L190.836 269.157L190.85 275.776L191.691 281.529L194.463 285.552L198.759 291.443L202.917 297.909L205.139 303.372L206.941 309.978L207.642 314.869L207.387 321.632L205.739 326.671L202.296 331.715L196.779 336.475L192.639 338.642L189.463 339.368L185.593 338.657L181.028 335.932L177.287 331.048L174.788 325.298L172.423 317.677L171.444 312.211L172.263 306.31Z",
    fill: "#FACC7D",
    stroke: "#FACC7D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.272 138.686C210.757 138.686 229.795 119.647 229.795 96.1623C229.795 72.6771 210.757 53.6387 187.272 53.6387C163.787 53.6387 144.748 72.6771 144.748 96.1623C144.748 119.647 163.787 138.686 187.272 138.686Z",
    fill: "#FCCC63"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 162.513,
    cy: 101.546,
    r: 5.92101,
    fill: "#DC9BA3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.956,
    cy: 91.8566,
    r: 5.92101,
    fill: "#DC9BA3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M179.197 107.467C189.963 110.697 195.884 109.62 202.343 101.008",
    stroke: "#3F3D56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M175.763 86.5298C172.539 83.9621 170.116 85.4601 169.942 88.9953",
    stroke: "#3F3D56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M198.366 81.8917C195.88 78.6038 193.161 79.4531 192.115 82.8346",
    stroke: "#3F3D56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1711 161C66.5928 161 75.8519 151.741 75.8519 140.319C75.8519 128.898 66.5928 119.639 55.1711 119.639C43.7494 119.639 34.4902 128.898 34.4902 140.319C34.4902 151.741 43.7494 161 55.1711 161Z",
    fill: "#505066"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.622 164.394C98.8436 164.394 112.804 151.052 112.804 134.594C112.804 118.137 98.8436 104.795 81.622 104.795C64.4003 104.795 50.4395 118.137 50.4395 134.594C50.4395 151.052 64.4003 164.394 81.622 164.394Z",
    fill: "#505066"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.758 163.939C114.675 163.939 125.146 153.468 125.146 140.551C125.146 127.634 114.675 117.162 101.758 117.162C88.8406 117.162 78.3691 127.634 78.3691 140.551C78.3691 153.468 88.8406 163.939 101.758 163.939Z",
    fill: "#505066"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.67 164.364C129.503 164.364 137.474 156.394 137.474 146.561C137.474 136.729 129.503 128.758 119.67 128.758C109.838 128.758 101.867 136.729 101.867 146.561C101.867 156.394 109.838 164.364 119.67 164.364Z",
    fill: "#505066"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0491 141.938C58.1741 141.938 60.7075 139.405 60.7075 136.28C60.7075 133.154 58.1741 130.621 55.0491 130.621C51.924 130.621 49.3906 133.154 49.3906 136.28C49.3906 139.405 51.924 141.938 55.0491 141.938Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1546 139.047C56.5538 139.047 57.6881 137.913 57.6881 136.514C57.6881 135.115 56.5538 133.98 55.1546 133.98C53.7554 133.98 52.6211 135.115 52.6211 136.514C52.6211 137.913 53.7554 139.047 55.1546 139.047Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4065 143.157C79.5316 143.157 82.0649 140.623 82.0649 137.498C82.0649 134.373 79.5316 131.84 76.4065 131.84C73.2814 131.84 70.748 134.373 70.748 137.498C70.748 140.623 73.2814 143.157 76.4065 143.157Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6432 139.927C78.0426 139.927 79.1771 138.793 79.1771 137.393C79.1771 135.994 78.0426 134.859 76.6432 134.859C75.2438 134.859 74.1094 135.994 74.1094 137.393C74.1094 138.793 75.2438 139.927 76.6432 139.927Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2226 130.054C79.7205 130.917 83.2441 133.473 83.483 136.415C83.9367 142.003 78.5829 135.865 77.0405 135.102C75.4981 134.339 71.7732 134.405 71.016 133.104C69.9903 131.411 72.0539 129.112 73.6468 129.042C74.6517 129.019 75.7775 129.757 76.733 129.857",
    fill: "#64647A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6797 129.705C58.6958 127.959 54.7331 126.157 52.0574 127.401C46.9735 129.766 54.9548 131.391 56.38 132.356C57.805 133.32 59.5871 136.592 61.0918 136.608C63.0707 136.664 64.0513 133.734 63.3258 132.315C62.8491 131.43 61.652 130.815 61.0928 130.033",
    fill: "#64647A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M324.344 163.795C312.516 163.795 302.928 154.206 302.928 142.379C302.928 130.551 312.516 120.963 324.344 120.963C336.172 120.963 345.76 130.551 345.76 142.379C345.76 154.206 336.172 163.795 324.344 163.795Z",
    fill: "#5D5C6F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M296.95 167.31C279.116 167.31 264.659 155.539 264.659 141.018C264.659 126.498 279.116 114.727 296.95 114.727C314.785 114.727 329.242 126.498 329.242 141.018C329.242 155.539 314.785 167.31 296.95 167.31Z",
    fill: "#5D5C6F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M276.099 166.839C262.722 166.839 251.878 155.994 251.878 142.618C251.878 129.241 262.722 118.396 276.099 118.396C289.476 118.396 300.32 129.241 300.32 142.618C300.32 155.994 289.476 166.839 276.099 166.839Z",
    fill: "#5D5C6F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M257.548 167.279C247.366 167.279 239.111 159.025 239.111 148.843C239.111 138.661 247.366 130.406 257.548 130.406C267.73 130.406 275.984 138.661 275.984 148.843C275.984 159.025 267.73 167.279 257.548 167.279Z",
    fill: "#5D5C6F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M324.29 146.513C321.684 146.513 319.571 144.4 319.571 141.794C319.571 139.189 321.684 137.076 324.29 137.076C326.895 137.076 329.008 139.189 329.008 141.794C329.008 144.4 326.895 146.513 324.29 146.513Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M325.154 144.555C323.748 144.555 322.607 143.414 322.607 142.008C322.607 140.601 323.748 139.461 325.154 139.461C326.561 139.461 327.701 140.601 327.701 142.008C327.701 143.414 326.561 144.555 325.154 144.555Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M308.397 147.009C305.791 147.009 303.679 144.896 303.679 142.291C303.679 139.685 305.791 137.572 308.397 137.572C311.003 137.572 313.115 139.685 313.115 142.291C313.115 144.896 311.003 147.009 308.397 147.009Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M308.847 145.023C307.482 145.023 306.375 143.911 306.375 142.54C306.375 141.168 307.482 140.057 308.847 140.057C310.212 140.057 311.318 141.168 311.318 142.54C311.318 143.911 310.212 145.023 308.847 145.023Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M305.645 135.212C303.145 135.755 299.465 137.807 298.899 140.607C297.821 145.926 303.671 140.641 305.241 140.084C306.811 139.528 310.383 140.019 311.26 138.855C312.44 137.345 310.721 134.899 309.198 134.649C308.235 134.512 307.068 135.092 306.138 135.079",
    fill: "#504F66"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M316.165 136.705C318.085 135.015 321.921 133.271 324.51 134.476C329.431 136.765 321.706 138.338 320.327 139.271C318.948 140.205 317.223 143.371 315.766 143.387C313.851 143.441 312.902 140.606 313.604 139.231C314.066 138.375 315.224 137.78 315.765 137.023",
    fill: "#504F66"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.236 97.5) rotate(90) scale(97.5 97)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F2D2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavebg2);
export default __webpack_public_path__ + "static/media/savebg2.e0f2c959334a010e14683837031e4203.svg";
export { ForwardRef as ReactComponent };